import React, { useCallback } from 'react'
import Icon from '@fortawesome/react-fontawesome'
import CategoriesAutoSuggest from './CategoriesAutoSuggest'
import CategoryBadge from './CategoryBadge'
import _ from 'lodash'
import AddCategoryButton from './AddCategoryButton'

const CategoryInput = ({
  form: { setFieldValue, errors, touched },
  field: { value, name }
}) => {
  const onSuggestionSelected = useCallback(
    (ev, { suggestion }) => {
      setFieldValue(name, [...value, suggestion])
    },
    [setFieldValue, name, value]
  )
  const onClickRemoveCategory = useCallback(
    category => () => {
      const nextCategories = [...value]
      const index = _.indexOf(value, category)
      nextCategories.splice(index, 1, {id: category.id, _destroy: '1'})
      setFieldValue(name, nextCategories);
    },
    [value, setFieldValue, name]
  )
  const onCategoryAdded = useCallback(
    category => {
      const nextCategories = [...value, category]
      setFieldValue(name, nextCategories)
    },
    [value, setFieldValue, name]
  )
  return (
    <div>
      <CategoriesAutoSuggest onSuggestionSelected={onSuggestionSelected} />
      {errors[name] && touched[name] && (
        <p className='text-danger'>{errors.categories}</p>
      )}
      {!_.isEmpty(value) && (
        <div className='row my-2 my-md-3'>
          {value.map((category, index) => {
            return (
              <div key={category.id} className='col-auto '>
                <CategoryBadge category={category}>
                  {({ category }) => (
                    <Icon
                      icon='times'
                      className='selectable'
                      onClick={onClickRemoveCategory(category)}
                    />
                  )}
                </CategoryBadge>
              </div>
            )
          })}
        </div>
      )}
      <AddCategoryButton onCategoryAdded={onCategoryAdded} />
    </div>
  )
}

export default CategoryInput
